import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal, message, Input } from 'antd';
import {
  UpOutlined,
  DownOutlined,
  LoadingOutlined,
  CheckCircleFilled,
} from '@ant-design/icons';
import {
  _change_pwd_modal,
  _clear_user_info,
  _emit_call,
} from '../../store/Action';
import Util from '../../script/util';
import HTTP from '../../script/service';
import './PwdModal.scss';
import NationCode from '../nationCode/nationCode';
import jxCaptchaVerifiedHOC from '../jxCaptchaVerifiedHOC';

const pwdreg =
  /^(?![A-Za-z0-9]+$)(?![a-z0-9~!@#$%^&*_?.]+$)(?![A-Za-z~!@#$%^&*_?.]+$)(?![A-Z0-9~!@#$%^&*_?.]+$)[a-zA-Z0-9~!@#$%^&*_?.]{8,16}$/;
let Password = Input.Password;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      current: 0,
      time: 0,
      param: {},
      setScene: 0, //0设置初始密码 1修改密码 2忘记密码
      nationVisible: false,
      nationCode: '86',
    };
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot) {
      if (this.props.base.userInfo && this.props.base.userInfo.bindAreaCode) {
        this.setState({ nationCode: this.props.base.userInfo.bindAreaCode });
      }
    }
  }
  getSnapshotBeforeUpdate(prevProps, prevState) {
    const { setPwd_visible: oldStatus } = prevProps.base;
    const { setPwd_visible: newStatus } = this.props.base;
    return newStatus !== oldStatus && !!newStatus ? 1 : null;
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
    this.setState = () => {
      return;
    };
  }
  hideModal = () => {
    if (this.props.base.setPwd_type == 0) {
      _emit_call({
        name: 'refresh_base',
      });
    }
    _change_pwd_modal({
      type: 0,
      show: false,
    });

    if (this.state.current === 1) {
      Util.delCookie('firstIn');
      _clear_user_info(true);
    } else {
      this.setState({
        current: 0,
        time: 0,
        param: {},
        setScene: 0,
        nationVisible: false,
      });
    }
    this.props.destroyCaptchaVerified();
  };
  //发送验证码
  sendCode = async () => {
    const {
      base,
      initCaptchaVerified,
      getCaptchaVerified,
      resetCaptchaVerified,
    } = this.props;
    const { rootConfig, userInfo, setPwd_type } = base;
    const { time, param, nationCode } = this.state;
    if (time) return false;
    let phone = param.phone;
    if (setPwd_type == 1) {
      //修改密码使用默认手机号
      phone = userInfo.bindPhone;
    }
    if (!Util.validationPhone(phone, nationCode)) return;
    if (getCaptchaVerified()) {
      // 重新获取验证码需要重置验证码
      resetCaptchaVerified();
      await Util.sleep(300);
    }

    const geeType = setPwd_type == 2 ? 1 : 2; // 忘记密码 geeType = 1
    initCaptchaVerified({ phone, nationCode, geeType }, () => {
      this.setState({ loading: true }, () => {
        let sendCodeApi = HTTP._send_code;
        const params = {
          phone,
          clientIp: '127.0.0.1',
          type: 2,
        };
        if (rootConfig.lang !== 'zh_CN') {
          params.areaCode = nationCode;
        }
        const geeValidate = getCaptchaVerified();
        sendCodeApi({ ...params, ...geeValidate })
          .then((res) => {
            if (res?.code === 200) {
              this.setState({ time: 60 }, () => {
                this.changeCodeTime();
              });
            } else {
              message.error(res?.message ?? '验证码发送失败，请稍后重试');
              if (res?.code === 5502) {
                // 发送验证时，验证码失效
                resetCaptchaVerified();
              }
            }
          })
          .finally(() => {
            this.setState({ loading: false });
          });
      });
    });
  };
  //改变时间
  changeCodeTime = () => {
    let { time } = this.state;
    clearTimeout(this.timer);
    if (time <= 0) return;
    this.setState({ time: time - 1 }, () => {
      this.timer = setTimeout(this.changeCodeTime, 1000);
    });
  };
  changeFormValue = (e) => {
    let { param } = this.state;
    param[e.target.name] = e.target.value.trim();
    this.setState({
      param: param,
    });
  };
  setPwd = () => {
    const {
      base,
      getCaptchaVerified,
      resetCaptchaVerified,
      destroyCaptchaVerified,
    } = this.props;
    const { rootConfig, setPwd_type, uid } = base;
    const { param, nationCode } = this.state;
    if (setPwd_type != 0) {
      if (setPwd_type != 1 && !Util.validationPhone(param.phone, nationCode)) {
        message.warning('请正确填写手机号码');
        return false;
      }
      if (!param.code) {
        message.warning('请正确填写手机验证码');
        return false;
      }
    }

    if (!param.pwd || !param.repeatPwd) {
      message.warning('请输入要设置的密码');
      return false;
    }
    if (!pwdreg.test(param.pwd) || !pwdreg.test(param.repeatPwd)) {
      message.warning(
        '密码必须同时包含数字、英文字母大小写，特殊字符。长度在8-16位。'
      );
      return false;
    }
    if (param.pwd != param.repeatPwd) {
      message.warning('两次输入的密码不一致');
      return false;
    }
    if (setPwd_type == 0) {
      HTTP._set_pwd({
        uid,
        password: param.pwd,
      }).then((res) => {
        if (res.code == 200) {
          this.setState({
            current: 1,
          });
        } else {
          message.error(res && res.message);
        }
      });
    } else if (setPwd_type == 1) {
      //修改密码
      const params = {
        uid,
        password: param.pwd,
        code: param.code,
      };
      if (rootConfig.lang !== 'zh_CN') {
        params.areaCode = nationCode;
      }
      // 是否通过验证
      if (!getCaptchaVerified()) {
        message.warning('请重新获取验证码');
        return;
      }
      const geeValidate = getCaptchaVerified();
      HTTP._reset_pwd({ ...params, ...geeValidate }).then((res) => {
        if (res.code == 200) {
          this.setState({ current: 1 });
          destroyCaptchaVerified();
        } else {
          message.error(res?.message ?? '操作失败，请稍后重试~');
          if (res?.code === 5502) {
            // 验证码失效，需要重新获取
            resetCaptchaVerified();
          }
        }
      });
    } else if (setPwd_type == 2) {
      //忘记密码
      const params = {
        uid,
        password: param.pwd,
        code: param.code,
        phone: param.phone,
      };
      if (rootConfig.lang !== 'zh_CN') {
        params.areaCode = nationCode;
      }
      // 是否通过验证
      if (!getCaptchaVerified()) {
        message.warning('请重新获取验证码');
        return;
      }
      const geeValidate = getCaptchaVerified();
      HTTP._forget_pwd({ ...params, ...geeValidate }).then((res) => {
        if (res.code == 200) {
          resetCaptchaVerified();
          this.setState({ current: 1 });
        } else if (res.code === 5502) {
          // 图形验证码失效
          resetCaptchaVerified();
          message.error(res && res.message);
        } else {
          message.error(res?.message ?? '操作失败，请稍后重试');
        }
      });
    }
  };
  getTitle = () => {
    const { setPwd_type } = this.props.base;
    let title = null;
    switch (setPwd_type) {
      case 0:
        title = {
          main: '设置登录密码',
          sub: '密码为包含大小写字母、数字、特殊符号的8-16位字符',
        };
        break;
      case 1:
        title = {
          main: '修改密码',
          sub: '密码为包含大小写字母、数字、特殊符号的8-16位字符',
        };
        break;
      case 2:
        title = {
          main: '忘记密码',
          sub: '手机验证之后重新设置您的登录密码',
        };
        break;
      default:
        break;
    }
    return title;
  };
  // 选择的区号
  selNation = (nation) => {
    this.setState({
      nationCode: nation.code,
      nationVisible: false,
    });
  };
  // 展示隐藏区号
  showNationCode = () => {
    const { setPwd_type } = this.props.base;
    if (setPwd_type === 2) {
      this.setState({ nationVisible: !this.state.nationVisible });
    }
  };

  render() {
    const { setPwd_visible, setPwd_type, rootConfig, userInfo } =
      this.props.base;
    const { loading, current, time, param, nationCode, nationVisible } =
      this.state;
    return (
      <Modal
        open={setPwd_visible}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        title={this.getTitle().main}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="750px"
        onCancel={this.hideModal}
      >
        <div className="pwd-plan">
          {current != 1 && (
            <div className="title">
              <h1>{this.getTitle().main}</h1>
              <p>{this.getTitle().sub}</p>
            </div>
          )}
          {current === 0 ? (
            <div className="pro-step">
              {setPwd_type != 0 && (
                <div className="form-row">
                  <label className="form-label">手机号码：</label>
                  <div className="form-control form-control-flex">
                    {rootConfig.lang != 'zh_CN' && (
                      <span
                        onClick={this.showNationCode}
                        className="nation-code"
                      >
                        +{nationCode}{' '}
                        {setPwd_type === 2 &&
                          (nationVisible ? <UpOutlined /> : <DownOutlined />)}
                      </span>
                    )}
                    <input
                      className="input-phone"
                      placeholder="请输入注册的手机号"
                      type="text"
                      name="phone"
                      autoComplete="off"
                      disabled={setPwd_type == 1 ? true : false}
                      defaultValue={
                        setPwd_type == 1
                          ? Util.getPrivatePhone(userInfo.bindPhone, nationCode)
                          : ''
                      }
                      onChange={this.changeFormValue}
                    />
                  </div>
                </div>
              )}
              {setPwd_type != 0 && (
                <div className="form-row">
                  <label className="form-label">短信验证码：</label>
                  <div className="form-control">
                    <input
                      placeholder="请输入短信验证码"
                      type="text"
                      name="code"
                      autoComplete="off"
                      onChange={this.changeFormValue}
                      maxLength="6"
                    />
                    <button
                      className="send-code"
                      disabled={time > 0 || loading}
                      onClick={this.sendCode}
                    >
                      {time ? `${time}s` : '发送验证码'}
                      {loading && <LoadingOutlined />}
                    </button>
                  </div>
                </div>
              )}
              <div className="form-row">
                <label className="form-label">登录密码：</label>
                <div className="form-control">
                  {/* autocomplete="new-password" chrome 浏览器下静止密码默认填充 */}
                  {/* eslint-disable react/jsx-no-duplicate-props */}
                  <input
                    placeholder="请输入密码"
                    type="password"
                    value={param.pwd}
                    name="pwd"
                    autoComplete="off"
                    autocomplete="new-password"
                    onChange={this.changeFormValue}
                  />
                </div>
              </div>
              <div className="form-row">
                <label className="form-label">确认密码：</label>
                <div className="form-control">
                  <input
                    placeholder="再次输入密码"
                    type="password"
                    value={param.repeatPwd}
                    name="repeatPwd"
                    autoComplete="off"
                    onChange={this.changeFormValue}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-control action">
                  <button className="daidai-btn-primary" onClick={this.setPwd}>
                    确定
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {current === 1 ? (
            <div className="pro-step">
              <div className="success-plan">
                <div className="icon-row">
                  <CheckCircleFilled />
                </div>
                <p>设置成功</p>
              </div>
            </div>
          ) : null}

          {/* 手机号地区选择 */}
          <NationCode
            className="change-nation-code"
            visible={nationVisible}
            base={this.props.base}
            selNation={this.selNation}
          />
        </div>
      </Modal>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(jxCaptchaVerifiedHOC(index), { withRef: true })
);
